import { useContext } from 'react'

import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { MaccsInternshipsContext } from '../../../Providers/MaccsInternshipsProvider'
import { isObject } from '../../../utils'

const MonthTitle = ({ index, isCurrentMonth, startDate, endDate }) => {
  const { highlightedIndexes } = useContext(MaccsInternshipsContext)

  const t = useSelector(selectTranslate)

  const isHighlighted = isObject(highlightedIndexes) && index >= highlightedIndexes.start && index <= highlightedIndexes.end

  const getClassName = (currentIndex, isHighlighted) => {
    let headerClassName = 'month'

    if (isCurrentMonth) {
      headerClassName += ' is-current-week'
    }

    if (isHighlighted) {
      headerClassName += ' highlighted'
    }

    return headerClassName
  }

  return (
    <th className={getClassName(index, isHighlighted)} style={{ minWidth: '100px' }}>
      <div>
        {t(startDate.format('MM/YYYY'))}<br />
      </div>
    </th>
  )
}

export default MonthTitle
